export default function ProgressRing({ value = 0, label, testId }) {
  const safeValue = Math.max(0, Math.min(value, 100));
  return (
    <div className="progress-ring" style={{ "--progress": `${safeValue}%` }} data-testid={testId}>
      <div className="progress-ring-inner">
        <span className="font-display text-3xl font-black" data-testid={`${testId}-value`}>{safeValue}%</span>
        <span className="text-xs font-black uppercase text-slate-500" data-testid={`${testId}-label`}>{label}</span>
      </div>
    </div>
  );
}